<section>
  <div>
    <i class="fa fa-cogs"></i>
    <h1 translate>system_down_label</h1>
    <h2 translate>system_down_subtext_label</h2>
    <a href="/" translate>back_to_login_page</a>
  </div>
</section>
